import { APLPageLayout } from 'legacy/hpscoutso/layout/aplPageLayout/APLPageLayout'
import { history } from 'legacy/lut/helpers/route'
import { FC, useState } from 'react'

import { Button } from 'core-components/library/button'
import { LoaderOverlay } from 'core-components/library/loader'

import { DocumentsHistory, useAplDocuments } from '../aplUploadForm'

import styles from './APLDocumentsHistory.module.scss'

export const APLDocumentsHistory: FC = () => {
  const [isLoading, setIsLoading] = useState(false)
  const { aplDocuments, isLoading: isAplDocumentsLoading } = useAplDocuments()

  return (
    <APLPageLayout isLoading={isLoading} setIsLoading={setIsLoading}>
      <Button variant="text" onClick={history.back} className={styles.backButton}>
        {'< Go back'}
      </Button>
      <LoaderOverlay show={isAplDocumentsLoading} />
      <DocumentsHistory documents={aplDocuments} />
    </APLPageLayout>
  )
}
